import { FilterNumberInput } from "components/FilterNumberInput";
import { useField } from "lib/form";
import React from "react";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const KilometerstandFilter = ({ condensed }) => {
    const [minValue, , onMinChange] = useField("minimumkilometerstand");
    const [maxValue, , onMaxChange] = useField("maximumkilometerstand");

    return (
        <Grid condensed={condensed}>
            <FilterNumberInput
                filterId="filter-kilometerstand-min"
                value={minValue}
                handleChange={(_, value) => onMinChange(value)}
                datalayerKey="kilometerstand.min"
                helpText="Van"
                classes="double left"
                data-testid="kilometerstand-min"
                ariaLabel="Minimale kilometerstand"
                numeric
            />
            <FilterNumberInput
                filterId="filter-kilometerstand-max"
                value={maxValue}
                handleChange={(_, value) => onMaxChange(value)}
                datalayerKey="kilometerstand.max"
                helpText="Tot"
                classes="double right"
                data-testid="kilometerstand-max"
                ariaLabel="Maximale kilometerstand"
                numeric
            />
        </Grid>
    );
};
